import Title from "antd/lib/typography/Title";
import { toTitleCase } from "../../../utils/commonfunction";

const thCss = {
  border: "1px solid black",
  padding: "6px 12px",
  display: "table-cell",
  color: "black",
};
const thCssHead = {
  border: "1px solid black",
  padding: "6px 12px",
  display: "table-cell",
  background: "#4561b9",
  color: "white",
  fontWeight: "bold",
};
const headRow = {
  display: "table-row",
  fontWeight: "900",
  color: "#ffffff",
};

export default function OrderDetailReportTemp(props) {
  const heads = props.headList || [];

  return (
    <div style={{ border: "1px solid gray", padding: 20, width: "100%" }}>
      <table
        style={{ borderCollapse: "collapse", width: "100%" }}
        id="table-to-xls"
      >
        <tbody>
          <tr>
            <td colSpan={heads.length || 6}>
              <Title level={4} style={{ textAlign: "center" }}>
                Call Center Order Detail
              </Title>
            </td>
          </tr>
          <tr>
            <td colSpan={heads.length || 6}>
              <Title level={5} style={{ textAlign: "center" }}>
                {props.subtitle || ""}
              </Title>
            </td>
          </tr>
          {heads.length > 0 && (
            <tr style={headRow}>
              {heads.map((x) => (
                <td key={x} style={thCssHead}>
                  {toTitleCase(String(x || ""))}
                </td>
              ))}
            </tr>
          )}
          {props?.list?.map((y, index) => (
            <tr key={index} style={{ pageBreakInside: "avoid" }}>
              {heads.map((x) => (
                <td key={x} style={thCss}>
                  {y[x]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
